import axios from "axios";
import router from "@/router";
import { Toast } from "vant";
// create an axios instance
console.log(process, 22);

const service = axios.create({
  baseURL: "https://tc.datingcloud.cn/v1/record", // url = base url + request url
  // baseURL: "http://192.168.2.114:9019/v1/record",

  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30 * 1000 // request timeout
});
service.defaults.retry = 2; //重试次数

service.defaults.retryDelay = 1500; //重试延时
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers["Content-Type"] = "application/json";

    // 确保请求使用HTTP而不是HTTPS
    // if (config.url && config.baseURL) {
    //   // 如果是相对路径请求，则确保基础URL是HTTP
    //   if (config.baseURL.startsWith("http://")) {
    //     // 确保完整的请求URL是HTTP
    //     if (config.url.startsWith("https://")) {
    //       config.url = config.url.replace("https://", "http://");
    //     }
    //   }
    // }

    return config;
  },
  error => {
    // do something with request error
    console.error(error); // for debug
    return Promise.reject("连接服务器超时，请检查网络");
  }
);

service.interceptors.response.use(
  response => {
    console.log(response);

    const code = response.data.code || 200;
    const res = response.data;
    console.log(res, code, 33);
    if (code != 200) {
      Toast(res.msg);
      return;
    }
    return res;
  },
  error => {
    // // 处理异常。
    console.log(localStorage.getItem("role"));
    if (
      JSON.stringify(error).indexOf("401") != -1 &&
      localStorage.getItem("role") &&
      !localStorage.getItem("login")
    ) {
      localStorage.removeItem("login_time");
      let content = JSON.parse(localStorage.getItem("url"));
      router.replace({
        name: "Login",
        query: { contentId: content.contentId }
      });
      return;
    }
    if (
      JSON.stringify(error).indexOf("401") != -1 &&
      localStorage.getItem("login")
    ) {
      localStorage.removeItem("login_time");
      router.replace({ name: "Login2" });
      return;
    }
    console.error("error", JSON.stringify(error));
    // return Promise.reject("error");

    let config = error.config;

    // 判断是否配置了重试

    if (!config || !config.retry) return Promise.reject(error);

    if (!config.shouldRetry || typeof config.shouldRetry != "function") {
      return Promise.reject(error);
    }

    //判断是否满足重试条件

    if (!config.shouldRetry(error)) {
      return Promise.reject(error);
    }

    // 设置重置次数，默认为0

    config.__retryCount = config.__retryCount || 0;

    // 判断是否超过了重试次数

    if (config.__retryCount >= config.retry) {
      return Promise.reject(error);
    }
    config.__retryCount += 1;

    //延时处理

    var backoff = new Promise(function(resolve) {
      setTimeout(function() {
        resolve();
      }, config.retryDelay || 1);
    });

    //重新发起axios请求

    return backoff.then(function() {
      return service(config);
    });
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js